import colors from 'theme/colors';
import { ISource } from '../../types';
import Styled from 'components/common/Styled';
import { useContext } from 'react';
import { ZoneContext } from 'context/ZoneContext';
import { useRegionContext } from 'context/RegionContext';
import { useAnalytics } from 'hooks/useAnalytics/useAnalytics';
import { getContentWithSearchHighlited } from 'pages/MapSearch/utils';
import useMapSearch from 'hooks/search/useMapSearch';

/**
 * Renders source
 * - with link if available
 * - without link if not available
 * - null if no title
 */
export const Source = ({ title, link }: ISource) => {
    const { zone, selectedStation } = useContext(ZoneContext);
    const { region } = useRegionContext();
    const { captureMantaCareEvent } = useAnalytics();
    const { getSearchWords } = useMapSearch();
    const searchWords = selectedStation ? getSearchWords(selectedStation.id) : [];

    const onSourceClick = () => {
        captureMantaCareEvent({
            type: 'map',
            action: 'drawer_link_interaction',
            metadata: {
                region: {
                    id: region.id,
                    name: region.name
                },
                map: { name: region.map.name },
                zone: { name: zone.name },
                station: {
                    id: selectedStation!.id,
                    name: selectedStation!.name,
                    type: selectedStation!.type,
                    description: selectedStation!.description
                },
                type: 'source',
                name: title,
                link
            }
        });
        window.open(link, '_blank');
    };

    if (!title) {
        return null;
    }

    return (
        <>
            <br />
            {link ? (
                <Styled.TextRouteAnchor
                    style={{ color: colors.royalBlue[500] }}
                    onClick={onSourceClick}
                    dangerouslySetInnerHTML={{ __html: getContentWithSearchHighlited(title, searchWords) }}
                ></Styled.TextRouteAnchor>
            ) : (
                <span dangerouslySetInnerHTML={{ __html: getContentWithSearchHighlited(title, searchWords) }}></span>
            )}
        </>
    );
};
